const DATE_FIELDS = ['date', 'day', 'week', 'month', 'quarter', 'year'];

export default DATE_FIELDS;
